import { configureStore } from '@reduxjs/toolkit';
import categoryReducer from './slices/categorySlice';
import UserJourneyDataSlice from './slices/UserJourneyDataSlice';
import UserDetailsSlice from './slices/UserDetailsSlice';
import apiBaseUrlSlice from "./slices/apiBaseUrlSlice"
import currencyReducer from './slices/currencySlice';

const store = configureStore({
  reducer: {
    categories: categoryReducer,
    userJourneyData: UserJourneyDataSlice,
    userDetailsData: UserDetailsSlice,
    apiBaseUrl:apiBaseUrlSlice,
    currency: currencyReducer,
    // You can add other reducers here if needed
  },
});

export default store;
